import { rightsizingRecommendationsAdvancedFiltersPreferenceKey } from "../../../thunks/rightsizing/getRightsizingRecommendationsAdvancedFiltersThunk";
import { cloudChiprApi } from "../../../../../services/cloudchipr.api";

export const getAdvancedFiltersUserPreferenceSelector =
  cloudChiprApi.endpoints.getUsersMeCurrentPreferenceByKey.select({
    key: rightsizingRecommendationsAdvancedFiltersPreferenceKey,
  });
